import { Mail } from "lucide-react";

export function InboxTab() {
  return (
    <div data-testid="admin-inbox-tab">
      <p className="font-mono text-xs text-dim mb-4">
        Contact form delivery architecture and response review workflow.
      </p>
      <div
        className="p-6 rounded bg-panelalt border border-white/10 font-mono text-xs space-y-4"
        data-testid="admin-inbox-google-forms-panel"
      >
        <div className="flex items-start gap-3">
          <Mail className="w-4 h-4 text-cyber mt-0.5 shrink-0" />
          <div className="space-y-1">
            <p className="text-cyber font-bold uppercase tracking-wider">
              Google Forms Contact Delivery
            </p>
            <p className="text-white text-sm font-bold">
              There is no internal website inbox.
            </p>
          </div>
        </div>

        <div className="space-y-2 text-[#cbd5e1] leading-relaxed">
          <p>
            Contact form submissions from the public home page are forwarded directly to the
            configured Google Form.
          </p>
          <p>
            Messages are not stored in this website&apos;s Cloudflare D1 database or in the
            private GitHub content repository.
          </p>
          <p className="text-dim">
            To review incoming inquiries, access responses directly through the configured
            Google Form&apos;s administrator response interface in Google Forms.
          </p>
        </div>
      </div>
    </div>
  );
}
